import { render, staticRenderFns } from "./PsConfigurationLink.vue?vue&type=template&id=649c58ea&scoped=true&"
import script from "./PsConfigurationLink.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationLink.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationLink.vue?vue&type=style&index=0&id=649c58ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c58ea",
  null
  
)

export default component.exports